'use client';

import { JSX } from 'react';

import { GoogleLoginOneTouchButton } from '../../../components/google-login/GoogleLoginOneTouchButton';
import { SignUpParams } from './SignUpParams';
import { useGoogleSignUpCallback } from './useGoogleSignUpCallback';

export function GoogleSignUpButton(params: SignUpParams): JSX.Element | null {
    const callback = useGoogleSignUpCallback(params);
    if (typeof window === 'undefined') {
        return null;
    }
    return (
        <div className="flex flex-row items-center justify-center w-full">
            <GoogleLoginOneTouchButton successCallback={callback} />
        </div>
    );
}
